import { Typography, Button, Dialog, DialogContent } from "@material-ui/core";
import "../styles/Globales.scss";
import React from "react";
import { observer } from "mobx-react";
import PropTypes from 'prop-types';
import popup from '../stores/PopupStore';

const styles = {
  popupstyle: { width: "100%" },
  popupTitle: { width: "100%" },
  iconStyle: { alignSelf: "center", marginRight: "10px" },
  panelStyle: { marginTop: "15px" },
};

class AutorizacionComponent extends React.Component {
  autorizar = () => {
    popup.hidePopupAutorizacionPrevired();
    if (this.props.onAutorizar) {
      this.props.onAutorizar();
    }
  };
  noAutorizar = () => {
    popup.hidePopupAutorizacionPrevired();
    if (this.props.onRechazar) {
      this.props.onRechazar();
    }
  };
  render() {
    return (
      <Dialog id="modal" modal="true" open={popup.popupAutorizacionPrevired.show} style={styles.popupstyle}>
        <DialogContent>
          <Typography className="subtitulo bold">autorización</Typography>
          <Typography className="parrafo">
            Por medio del presente, autorizo a Banco Ripley a remitirse al sistema PreviRed para recolectar, almacenar y usar mis datos personales que sean necesarios para efectos de validar mi
            renta, con el objetivo de contatar y recibir los servicios relacionados a productos financieros. El tratamiento de mis datos personales se extenderá por el tiempo que dure dicha
            finalidad, y se hará conforme a la ley Nº19.628 sobre la Vida Privada.
          </Typography>
          <div className="contenedorBtnFondo">
            <div className="botonesAutorizacion">
              <Button className="btnRipleyAutorizacion btnGris" onClick={this.noAutorizar}>
                no autorizo
              </Button>
              <Button className="btnRipleyAutorizacion" onClick={this.autorizar}>
                autorizo
              </Button>
            </div>
          </div>
        </DialogContent>
        <div>
          <div className="franjaColores">
            <div className="rojo" />
            <div className="amarillo" />
            <div className="morado" />
          </div>
        </div>
      </Dialog>
    );
  }
}

AutorizacionComponent.propTypes = {
  onAutorizar: PropTypes.func.isRequired,
  onRechazar: PropTypes.func.isRequired,
};

export default observer(AutorizacionComponent);

